import { render, staticRenderFns } from "./InfoLocoPage.vue?vue&type=template&id=46e0ace2&scoped=true&"
import script from "./InfoLocoPage.vue?vue&type=script&lang=js&"
export * from "./InfoLocoPage.vue?vue&type=script&lang=js&"
import style0 from "./InfoLocoPage.vue?vue&type=style&index=0&id=46e0ace2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e0ace2",
  null
  
)

export default component.exports